module.exports = "/_next/static/videos/game3-intro-f49812c065b1c15171140a802a5ec77f.mp4";